import axios from 'axios';
export default class UserInfo {
    constructor() {
      if(localStorage.getItem("nx_ag")!=null){
        const data=JSON.parse(localStorage.getItem("nx_ag"))
        this.TOKEN = data['token']; 
        this.ORG_ID = data['organization']['organization_id']; 
        this.AGENT_NAME=data['first_name']+" "+data['last_name'];
        this.USERNAMES=data['first_name']+" "+data['last_name'];
        this.SHORT=data['first_name'].substr(0, 1);
        
      }

      if(localStorage.getItem("agent_profile")!=null){
        const data=JSON.parse(localStorage.getItem("agent_profile"));
        this.CODE=data['code'];
        this.TIN_NUMBER=data['tin_number'];
        // console.log("===local storage===",localStorage.getItem("agent_profile"));
        
      }
    }


}


export  {UserInfo};